<template>
  <v-card>
    <v-card-title>本番環境移行前 最終確認</v-card-title>
    <v-card-text>
      <v-container>
        <!--
        <div v-for="(page, Index) in pages"  :key="`[17-${Index}`">
          <v-row justify="center">
            <v-col md="12" align="center">
              {{page.ID}}
              {{page.title}}
            </v-col>
          </v-row>
        </div>
        -->
        <v-row>
          選択したreports/recodesテーブルのみ本番環境へ持ち越す
          *form等は更新される
          <v-select
            v-model="returnData.MoveReprots"
            :items="pages"
            item-text="title"
            item-value="ID"
            outlined
            multiple
          >
          </v-select>
        </v-row>
        <v-row justify="center">
          <v-col md="12" align="center">
            <div
              v-if="this.type == 'important'"
              style="margin-left: 20px;display: table;font-size: 15px;font-weight: 900;color: red;height: 300px;"
            >
              <span style="display: table-cell;vertical-align: bottom;">
                {{ message }}
              </span>
            </div>
            <div
              v-else
              style="margin-left: 20px;font-size:15px;font-weight: 200;"
            >
              {{ message }}
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="no()">No</v-btn>
      <v-btn color="green darken-1" text @click="yes()">Yes</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  props: {
    message: String,
    tag: String,
    type: String,
  },
  data() {
    return {
      returnData: {
        MoveReprots: [],
      },
      pages: [],
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      const pages = await api.getPage();
      const tmp = pages.map(function(row) {
        let tmp;
        let icon = "";
        //先頭アイコン登録
        switch (row["page_template_ID"]) {
          case 2: //帳票作成・更新
            icon = "●";
            break;
          case 6: //サブ帳票
            icon = "・";
            break;
          case 7: //ユーザ情報設定
            icon = "▲";
            break;
          default:
        }

        if (row["title"] == "") {
          tmp = { ID: row["ID"], title: icon + row["component_name"] };
        } else {
          tmp = { ID: row["ID"], title: icon + row["title"] };
        }
        return tmp;
      });

      this.pages = tmp;
    },
    yes() {
      this.$emit("clickSubmit", true, this.tag, this.returnData);
    },
    no() {
      this.$emit("clickSubmit", false, this.tag, this.returnData);
    },
  },
};
</script>
